// @flow

import React from 'react'
import { styles as s, selectStyles } from './style'
import commonStyles from '../../../commonStyles'

// Components
import InteractiveSelect from 'hfty-map-dom/src/components/GridControls/InteractiveSelect'

// Constants
import { SIZE_TOOL_CONFIG as gridSizeConfig } from 'hfty-map-dom/src/constants'

export default class SoilSampleCard extends React.Component {
  props: {
    data: Object,
    onUpdateCardTotalCost: Function,
  }

  state: {
    packs: Array<Object>,
    activePack: Object,
    activePackIndex: number,
    calculatorValues: Object,
  }

  constructor (props: Object) {
    super(props)
    this.options = []

    for (let i = gridSizeConfig.MIN_VALUE; i <= gridSizeConfig.MAX_VALUE; i += gridSizeConfig.STEP) {
      this.options.push({
        value: i,
        label: i,
      })
    }

    const selectedOption = this.getSelectedOption(gridSizeConfig.DEFAULT_VALUE)

    this.state = {
      packs: this.generatePacks(),
      activePack: null,
      activePackIndex: 0,
      calculatorValues: {
        acres: '',
        grid: gridSizeConfig.DEFAULT_VALUE,
        bags: '',
      },
      selectedOption,
    }
  }

  componentDidUpdate (prevProps: Object, prevState: Object) {
    if (this.state.calculatorValues.bags !== prevState.calculatorValues.bags) {
      this.setActivePackToSelector(this.state.calculatorValues.bags)
    }

    if (this.state.activePack !== prevState.activePack) {
      this.props.onUpdateCardTotalCost({
        supply: this.props.data.id,
        quantity: this.state.activePack.packs,
        cost: parseInt(this.state.activePack.price),
      })
    }
  }

  getSelectedOption (value: number): Object {
    return this.options.find((opt: Object): boolean => opt.value === value)
  }

  render (): React.Element<any> {
    const { data } = this.props
    const { calculatorValues, packs, activePackIndex, activePack } = this.state

    return (
      <div style={s.soilSampleCard}>
        <div style={s.cardMain}>
          <div>
            <h3 style={commonStyles.h3}>
              { data.name }
            </h3>
            <span style={s.descriptionListTitle}>
              Each pack includes:
            </span>
            <ul style={s.descriptionList}>
              <li style={s.descriptionListItem}>25 sample bags</li>
              <li style={s.descriptionListItem}>1 box</li>
              <li style={s.descriptionListItem}>1 postage-paid return label</li>
            </ul>
          </div>

          <div style={s.calculator}>
            <div style={s.calculatorHeader}>
              <span>Supplies Calculator</span>
            </div>

            <div style={s.calculatorContent}>
              <label style={s.calculatorField}>
                <span style={s.calculatorFieldTitle}>Acres To Sample</span>
                <input
                  name='acres'
                  type='number'
                  value={calculatorValues.acres}
                  onChange={this.onCalcFieldChange}
                  style={s.calculatorFieldInput}
                />
              </label>

              <span style={s.calculatorSign}>÷</span>
              <label style={s.calculatorField}>
                <span style={s.calculatorFieldTitle}>Grid <br /> Size</span>
                <InteractiveSelect
                  config={gridSizeConfig}
                  value={this.state.calculatorValues.grid}
                  options={this.options}
                  selectedOption={this.state.selectedOption}
                  onChange={this.handleGridSizeChange}
                  getSelectedOption={this.getSelectedOption}
                  style={selectStyles}
                  stylingClasses='select-order-supplies'
                />
              </label>
              <span style={s.calculatorSign}>=</span>
              <label style={s.calculatorField}>
                <span style={s.calculatorFieldTitle}># of Bags</span>
                <input
                  name='bags'
                  type='number'
                  value={calculatorValues.bags}
                  onChange={this.onCalcFieldChange}
                  style={s.calculatorFieldInput}
                />
              </label>
            </div>

            <div style={s.calculatorFooter}>
              <span style={s.calculatorFooterTitle}>
                {`Maximum grid size is ${gridSizeConfig.MAX_VALUE} acres`}
              </span>
            </div>
          </div>

          <div style={s.selectorAndTotal}>
            <div style={s.qty}>
              <span style={s.qtyTitle}>
                Qty:
              </span>
              <div style={s.qtyWrapper}>
                <select
                  value={activePackIndex}
                  name='select-pack'
                  onChange={this.handleSelectPackChange}
                  style={s.qtySelect}
                >
                  { packs.map((option: Object, key: number): React.Element<any> => {
                    return (
                      <option key={key} value={packs.indexOf(option)}>
                        {option.name}
                      </option>
                    )
                  }) }
                </select>
              </div>
            </div>

            <div style={s.total}>
              <span style={s.totalText}>
                $ { activePack ? activePack.price : 0 }
              </span>
            </div>
          </div>
        </div>

        <div style={s.bottomTitle}>
          Pricing for the pack is for shipping from/to Farmers Edge Laboratories
        </div>
      </div>
    )
  }

  handleSelectPackChange = (e: Function) => {
    this.setState({
      ...this.state,
      activePackIndex: parseInt(e.target.value),
      activePack: this.state.packs[parseInt(e.target.value)],
    })
  }

  handleGridSizeChange = (value: number) => {
    const opt = {
      target: {
        value,
        name: 'grid',
      },
    }

    this.onCalcFieldChange(opt)
  }

  appendMaxPack = (val: number): Object => {
    const { base_price, quantity_price } = this.props.data
    const packs = (val / 25).toFixed()

    return {
      name: `${packs} packs [${val} bags]`,
      packs: packs,
      value: val,
      price: Math.floor(packs / 2) * quantity_price + ((packs % 2) * base_price),
    }
  }

  setActivePackToSelector = (val: number): null => {
    const { packs } = this.state
    const pack = packs.find((item: Object): Object => item.value >= val)
    const maxElement = Math.max.apply(Math, packs.map((el: Object): Array<number> => el.value))

    if (val <= maxElement) {
      if (val > 500) {
        let updatedPacks = packs
        updatedPacks.pop()

        updatedPacks = [
          ...updatedPacks,
          this.appendMaxPack(val),
        ]

        this.setState({
          ...this.state,
          activePack: this.appendMaxPack(val),
          packs: [
            ...updatedPacks,
          ],
          activePackIndex: this.state.packs.length,
        })

        return
      }

      if (this.state.activePack !== packs[packs.indexOf(pack)]) {
        this.setState({
          ...this.state,
          activePack: pack,
          activePackIndex: packs.indexOf(pack),
        })
      }
    } else if (val > maxElement) {
      this.setState({
        ...this.state,
        activePack: this.appendMaxPack(val),
        packs: [
          ...this.state.packs,
          this.appendMaxPack(val),
        ],
        activePackIndex: this.state.packs.length,
      })
    }
  }

  generatePacks = (): Array<Object> => {
    const { base_price, quantity_price } = this.props.data
    const packs = []

    packs[0] = { name: 'Select # of pack(s)', value: 0, price: 0 }

    for (let i = 1; i <= 20; i++) {
      packs[i] = {
        name: `${i} pack [${i * 25} bags]`,
        packs: i,
        value: i * 25,
        price: Math.floor(i / 2) * quantity_price + ((i % 2) * base_price),
      }
    }

    return packs
  }

  onCalcFieldChange = (e: Object) => {
    const { acres, grid, bags } = this.state.calculatorValues
    let { value, name } = e.target

    if (value < 0) {
      value = -value
    }

    switch (name) {
      case 'acres':
        this.setState({
          ...this.state,
          calculatorValues: {
            ...this.state.calculatorValues,
            acres: value,
            bags: Math.round(grid ? value / grid : bags),
          },
        })
        break

      case 'grid':
        this.setState({
          ...this.state,
          calculatorValues: {
            ...this.state.calculatorValues,
            grid: value,
            bags: Math.round(value ? acres / value : bags),
          },
          selectedOption: this.getSelectedOption(value),
        })
        break

      case 'bags':
        this.setState({
          ...this.state,
          calculatorValues: {
            ...this.state.calculatorValues,
            bags: Math.round(value),
            acres: value ? grid * value : acres,
          },
        })
        break
    }
  }
}
